import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import i18next from "i18next";

import config from "config";

const ChecklistImage = ({ imgUrl }) => {
    const [showChecklistImageModal, setShowChecklistImageModal] = useState(false);

    const toggleChecklistImageModal = () => {
        setShowChecklistImageModal(!showChecklistImageModal);
    }

    return (
        <div>

            <div className="checklist-image-container">
                <img className='checklist-image-in-situ' src={imgUrl} onClick={toggleChecklistImageModal} />
                <img className="checklist-image-zoom" src={`${config.WEB_BASE_URL}/images/icon/enlarge.svg`} onClick={toggleChecklistImageModal} />
            </div>

            <Modal dialogClassName="devices" show={showChecklistImageModal} onHide={toggleChecklistImageModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{i18next.t('checklist-image')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <img src={imgUrl} alt={i18next.t('checklist-image')} />
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    );
}

export default ChecklistImage;